import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

import localStyles from "./ExpandableRow.module.scss";

const ExpandableRow = ({ row, renderExpandedContent, colSpan, prepareRow, onRowClick, compactBody = false, rowClassName = "", styles }) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const appliedStyles = styles || localStyles;

	const toggleExpand = (e) => {
		e.stopPropagation();
		setIsExpanded(!isExpanded);
	};

	prepareRow(row);
	const { key: rowKey, ...rowProps } = row.getRowProps();

	return (
		<React.Fragment key={rowKey}>
			<tr
				{...rowProps}
				className={`${appliedStyles.tr} ${isExpanded ? appliedStyles.trExpanded : ""} ${onRowClick ? appliedStyles.trClickable : ""} ${rowClassName}`}
				onClick={onRowClick ? () => onRowClick(row) : undefined}
			>
				{row.cells.map((cell, index) => {
					const { key, ...cellProps } = cell.getCellProps();
					const extraClass = cell.column?.meta?.cellClassName ? appliedStyles[cell.column.meta.cellClassName] : "";
					const compactClass = compactBody ? appliedStyles.tdCompact : "";
					const titleText = typeof cell.value === "string" ? cell.value : undefined;

					const isLastCell = index === row.cells.length - 1;

					return (
						<td key={key} {...cellProps} className={`${appliedStyles.td} ${extraClass} ${compactClass}`} title={titleText}>
							<span className={appliedStyles.cellInner}>
								{cell.render("Cell")}
								{isLastCell && (
									<button
										type="button"
										className={appliedStyles.expandButton}
										onClick={toggleExpand}
										aria-label={isExpanded ? "Contraer" : "Expandir"}
										title={isExpanded ? "Contraer" : "Expandir"}
									>
										{isExpanded ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
									</button>
								)}
							</span>
						</td>
					);
				})}
			</tr>

			{isExpanded && (
				<tr className={appliedStyles.expandedRow}>
					<td colSpan={colSpan} className={appliedStyles.expandedCell}>
						{renderExpandedContent(row)}
					</td>
				</tr>
			)}
		</React.Fragment>
	);
};

export default ExpandableRow;
